import axios from 'axios'
import Bus from './bus'
// import store from '../store';
import { Message } from 'element-ui'
import router from '../router.js'

const fetch = axios.create({
  // baseURL: '',
  timeout: 20000,
  withCredentials: true
})
let that = this
let pending = []
const CancelToken = axios.CancelToken
let removePending = (ever) => {
  for (let p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}
// 请求拦截器
fetch.interceptors.request.use(config => {
  removePending(config)
  config.cancelToken = new CancelToken(c => {
    pending.push({ u: config.url + '&' + config.method, f: c })
  })
  if (localStorage.token) {
    config.headers.common['accessToken'] = localStorage.token
  }
  return config
}, erro => Promise.reject(erro))
// 响应拦截器
fetch.interceptors.response.use((response) => {
  removePending(response.config)
  const { status, data } = response
  // 只返回code为1时的数据，其他状态不返回
  if (status === 200 && data.code === 1) {
    return data.data
  }
  if (status === 200 && data.code === -3) {
    router.replace('/login')
    localStorage.clear()
  }
  Message.error({
    message: data.msg
  })
  // Bus.$emit('_Error', data.msg)
  return Promise.reject(data.msg)
}, (error) => {
  const res = error.response
  console.log(error)
  if (!error) {
    if (res.status === 401) {
      const msg = res.data.msg || '请重新登录'
      Message.error({
        message: msg
      })
      Bus.$emit('_Unauth', data.msg)
    }
    /* todo */
    return Promise.reject(error)
  }
})

export default fetch
